/**
 * Created by Rumyantsev Daniil on 15.02.2018.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Возвращает модуль числа
 *
 * Usage:
 *   numberValue | abs
 * Example:
 *   {{ -420.42 | abs}}
 *   formats to: 420.42
 */
@Pipe({name: 'abs'})
export class AbsValuePipe implements PipeTransform {

  transform(value: number): number {

    return Math.abs(value);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/abs-value.pipe.ts